import React from "react";

export function replaceLineBreaks(s: string): React.ReactNodeArray {
  return s.split("\n").flatMap((s, i) => (i == 0 ? [s] : [<br key={i} />, s]));
}
